/* Polsk katalog for locale-no.js (del 4 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Możliwe skrócenie okresu kredytowania',
  'adv.sales.move.chaseSlowPayers.effectNote': 'do Twojej własnej średniej — efekt w koronach zależy od tego, kiedy klient faktycznie zapłaci',
  'adv.sales.move.chaseSlowPayers.action': 'Zobacz listę faktur',
  'adv.sales.move.reviewDiscounts.title': 'Przejrzyj rabaty',
  'adv.sales.move.reviewDiscounts.text': 'W tym roku udzieliłeś rabatów na kwotę {amount}, średnio {pct} % na fakturę.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Szacowany efekt',
  'adv.sales.move.reviewDiscounts.effectNote': 'przy zmniejszeniu rabatów o połowę',
  'adv.sales.move.reviewDiscounts.action': 'Zobacz listę faktur',
  'adv.sales.move.spreadCustomers.title': 'Zdywersyfikuj bazę klientów',
  'adv.sales.move.spreadCustomers.text': '{name} odpowiada za {pct} % sprzedaży. Jeden klient nie powinien sam dźwigać obrotu.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Udział największego klienta',
  'adv.sales.move.spreadCustomers.effectNote': 'to ryzyko, a nie zysk',
  'adv.sales.move.spreadCustomers.action': 'Zobacz klientów',
  'adv.sales.move.testPriceIncrease.title': 'Rozważ podwyżkę cen',
  'adv.sales.move.testPriceIncrease.text': 'Sprawdź, jak cena wyższa o {pct} % wpłynie na obrót, zanim podejmiesz decyzję.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Szacowany efekt roczny',
  'adv.sales.move.testPriceIncrease.effectNote': 'przy obecnym wolumenie',
  'adv.sales.move.testPriceIncrease.action': 'Zobacz produkty',
  'adv.sales.move.growRecurring.title': 'Zwiększ sprzedaż cykliczną',
  'adv.sales.move.growRecurring.text': '{pct} % sprzedaży to sprzedaż cykliczna. Jeśli zbliżysz się do {target} %, obrót stanie się znacznie bardziej przewidywalny.',
  'adv.sales.move.growRecurring.effectLbl': 'Obrót, który może stać się przewidywalny',
  'adv.sales.move.growRecurring.effectNote': 'jeśli udział osiągnie cel',
  'adv.sales.move.growRecurring.action': 'Zobacz subskrypcje',
  'adv.sales.scn.title': 'Scenariusze sprzedaży — Co się stanie, jeśli …',
  'adv.sales.scn.sub': 'Wpływ na obrót, wynik i płynność',
  'adv.sales.scn.help': 'Wybierz scenariusz, aby zobaczyć stan przed i po dla obrotu, wyniku, marży i płynności, wraz z przyjętymi przeze mnie założeniami. Liczby są wyliczeniami, a nie gwarancjami.',
  'adv.sales.scn.metric': 'Wskaźnik',
  'adv.sales.scn.base': 'Podstawa',
  'adv.sales.scn.after': 'Po scenariuszu',
  'adv.sales.scn.change': 'Zmiana',
  'adv.sales.scn.row.revenue': 'Obrót',
  'adv.sales.scn.row.result': 'Wynik',
  'adv.sales.scn.row.margin': 'Marża zysku',
  'adv.sales.scn.row.liquidity': 'Wyliczone saldo planowane',
  'adv.sales.scn.points': '{points} p.p.',
  'adv.sales.scn.assumptions': 'Założenia',
  'adv.sales.scn.showAssumptions': 'Pokaż założenia',
  'adv.sales.scn.confidence': 'Pewność',
  'adv.sales.scn.risk': 'Ryzyko',
  'adv.sales.scn.scope': 'Zakres',
  'adv.sales.scn.q.priceUp': 'Podnoszę ceny',
  'adv.sales.scn.q.volumeDown': 'Wolumen sprzedaży spada',
  'adv.sales.scn.q.halveDiscounts': 'Usuwam połowę rabatów',
  'adv.sales.scn.q.loseTopCustomer': 'Tracę klienta: {name}',
  'adv.sales.scn.q.growRecurring': 'Sprzedaż cykliczna rośnie o {pct} %',
  'adv.sales.scn.summary.priceUp': 'Przy obecnym wolumenie podwyżka cen o {pct} % daje około {delta} więcej rocznego obrotu. Podwyżka cen nie powoduje dodatkowych kosztów towarów ani godzin, więc cała kwota przekłada się na wynik.',
  'adv.sales.scn.summary.volumeDown': 'Spadek wolumenu o {pct} % zabiera około {delta} z obrotu. Wyliczenie zakłada, że koszty pozostają bez zmian, więc to najsurowszy wynik — jeśli zakupy spadną wraz z wolumenem, strata będzie mniejsza.',
  'adv.sales.scn.summary.halveDiscounts': 'W tym roku udzielono rabatów na kwotę {amount}, średnio {pct} %. Zmniejszając ten poziom o połowę, odzyskasz około {delta} — pod warunkiem, że klienci zostaną.',
  'adv.sales.scn.summary.loseTopCustomer': 'Jeśli {name} odejdzie, stracisz {delta} — {pct} % sprzedaży. Ta liczba sprawia, że warto zdywersyfikować bazę klientów, zanim to nastąpi.',
  'adv.sales.scn.summary.growRecurring': 'Jeśli sprzedaż cykliczna wzrośnie o {pct} %, da to około {delta} więcej rocznie. Przychody cykliczne to najbardziej przewidywalny obrót, jaki masz.',
  'adv.sales.scn.assumption.priceUp': 'Wolumen się utrzymuje. Dotyczy wszystkich produktów i usług.',
  'adv.sales.scn.assumption.volumeDown': 'Koszty pozostają bez zmian. Plumme nie ma kosztu własnego dla każdego produktu, więc nie mogę obliczyć, jaka część kosztów spada wraz z wolumenem.',
  'adv.sales.scn.assumption.halveDiscounts': 'Klienci kupują tyle samo przy niższym rabacie. Obliczono na podstawie rabatów faktycznie udzielonych w tym roku.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Żadna część obrotu nie zostanie zastąpiona przez innych klientów. Obliczono na podstawie faktycznie zaksięgowanej sprzedaży klienta.',
  'adv.sales.scn.assumption.growRecurring': 'Wzrost dochodzi do obecnej sprzedaży, a nie ją zastępuje.',
  'adv.sales.scn.riskText.priceUp': 'Jeśli wolumen spadnie bardziej, niż wzrośnie cena, efekt zniknie. Obserwuj wolumen sprzedaży przez pierwsze dwa miesiące.',
  'adv.sales.scn.riskText.volumeDown': 'Jeśli wolumen spadnie najpierw u najbardziej rentownych klientów, strata będzie większa.',
  'adv.sales.scn.riskText.halveDiscounts': 'Klienci kupujący ze względu na rabat mogą odejść. Najpierw przetestuj to na kilku.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Koszty stałe nie znikają razem z klientem, więc wynik ucierpi bardziej niż obrót.',
  'adv.sales.scn.riskText.growRecurring': 'Umowy cykliczne wiążą Cię ceną i dostawami na dłuższy czas.',
  'adv.sales.scn.scopeText.all': 'Wszystkie produkty i usługi',
  'adv.sales.scn.scopeText.discounted': 'Tylko faktury z rabatem',
  'adv.sales.scn.scopeText.topCustomer': 'Tylko największy klient',
  'adv.sales.scn.scopeText.recurring': 'Tylko sprzedaż cykliczna',
  'adv.sales.closerTag': 'Ja zrobiłbym tak',
  'adv.tab.tax': 'Podatki',
  'adv.tab.budget': 'Budżet',
  'adv.tab.insight': 'Wnioski',
  'adv.plan.title': 'Budżet a wykonanie',
  'adv.plan.sub': '{year} — zaksięgowano dotychczas w porównaniu z budżetem na pierwsze miesiące (liczba: {months})',
  'adv.plan.help': 'Zaksięgowane dane obejmują rok do dziś, a budżet cały rok. Dlatego porównuję z budżetem do bieżącego miesiąca włącznie — inaczej w styczniu wszystko wyglądałoby na dużo poniżej budżetu.',
  'adv.plan.tableTitle': 'Odchylenie według kategorii',
  'adv.plan.tableSub': 'Budżet na pierwsze miesiące ({months}) a zaksięgowane',
  'adv.plan.tableHelp': 'Wiersze są posortowane według wielkości odchylenia. Pokazywane są też konta z księgowaniami, ale bez budżetu — często są najciekawsze.',
  'adv.plan.col.category': 'Kategoria',
  'adv.plan.col.budget': 'Budżet do dziś',
  'adv.plan.col.actual': 'Zaksięgowano',
  'adv.plan.col.variance': 'Odchylenie',
  'adv.plan.unbudgeted': 'Poza budżetem',
  'adv.plan.incomeVariance': 'Odchylenie przychodów',
  'adv.plan.costVariance': 'Odchylenie kosztów',
  'adv.plan.abovePlan': 'powyżej planu',
  'adv.plan.belowPlan': 'poniżej planu',
  'adv.plan.overPlan': 'powyżej planu',
  'adv.plan.underPlan': 'poniżej planu',
  'adv.plan.separateNote': 'Odchylenia przychodów i kosztów są pokazywane osobno. Po zsumowaniu niedobór przychodów i oszczędność na kosztach mogłyby się znosić i wyglądać, jakby wszystko szło zgodnie z planem.',
  'adv.plan.noteWorse': '{name} odbiega o {amount} w złym kierunku po {months} mies. Warto się temu przyjrzeć, zanim odchylenie urośnie w dalszej części roku.',
  'adv.plan.noteBetter': '{name} wypada o {amount} lepiej niż w budżecie po {months} mies.',
  'adv.plan.noteUnbudgeted': 'Na {name} zaksięgowano {amount}, choć konto nie jest ujęte w budżecie.',
  'adv.plan.editBudget': 'Zmień budżet',
  'adv.plan.noBudgetTitle': 'Brak budżetu na ten rok',
  'adv.plan.noBudgetText': 'Bez budżetu nie mam z czym porównać zaksięgowanych danych. Jeśli go dodasz, pokażę odchylenia według kategorii i dam znać, gdy coś odbiega od planu.',
  'adv.plan.goToBudget': 'Utwórz budżet',
  'adv.plan.notStartedTitle': 'Rok jeszcze się nie zaczął',
  'adv.plan.notStartedText': 'W {year} nie ma jeszcze zaksięgowanych miesięcy, z którymi można porównać budżet.',
  'adv.plan.goalsTitle': 'Cele',
  'adv.plan.goalsSub': 'Twoje własne cele mierzone względem zaksięgowanych danych',
  'adv.plan.goalsHelp': 'Cel jest widoczny od roku, dla którego go utworzysz, dopóki nie oznaczysz go jako ukończony. Cel z minionym terminem pozostaje widoczny, dopóki go ponownie nie ocenisz. Przychód, wynik i marża są mierzone dla każdego roku obrotowego, a bufor śledzi saldo.',
  'adv.plan.goalsEmptyTitle': 'Nie ustawiono jeszcze celów',
  'adv.plan.goalsEmptyText': 'Ustaw cel z terminem — na przykład bufor gotówkowy lub marżę zysku — a będę śledzić postępy i dam znać, jeśli zostaniesz w tyle.',
  'adv.plan.goalNew': 'Nowy cel',
  'adv.plan.goalEdit': 'Edytuj cel',
  'adv.plan.goalSave': 'Zapisz cel',
  'adv.plan.goalSaved': 'Cel został zapisany',
  'adv.plan.goalSaveFailed': 'Nie udało się zapisać celu',
  'adv.plan.goalDeleted': 'Cel został usunięty',
  'adv.plan.goalTitleLabel': 'Jaki jest cel?',
  'adv.plan.goalTitlePh': 'Np. Zbuduj bufor gotówkowy przed końcem roku',
  'adv.plan.goalMetricLabel': 'Co ma być mierzone?',
  'adv.plan.goalMetricHint': 'Bieżąca wartość pochodzi z ksiąg, a nie z tego, co wpiszesz.',
  'adv.plan.goalTargetAmount': 'Wartość docelowa (kr)',
  'adv.plan.goalTargetPct': 'Wartość docelowa (%)',
  'adv.plan.goalNow': 'Teraz',
  'adv.plan.goalTarget': 'Cel',
  'adv.plan.goalDeadline': 'Termin',
  'adv.plan.goalDaysLeft': 'Pozostało dni',
  'adv.plan.goalMeasured': 'Mierzone względem: {metric}',
  'adv.plan.goalFromYear': 'Od {year}',
  'adv.plan.goalReached': 'Osiągnięto',
  'adv.plan.goalCompleted': 'Ukończono',
  'adv.plan.goalNeedsReview': 'Termin minął – oceń cel',
  'adv.plan.goalComplete': 'Oznacz cel jako ukończony',
  'adv.plan.goalReopen': 'Otwórz cel ponownie',
  'adv.plan.goalOverdue': 'Termin minął',
  'adv.plan.goalOnTrack': 'Zgodnie z planem',
  'adv.plan.goalBehind': 'Za planem',
  'adv.plan.goalTracking': 'Śledzenie',
  'adv.plan.metric.buffer': 'Stan gotówki na koniec roku',
  'adv.plan.metric.income': 'Zaksięgowany obrót',
  'adv.plan.metric.result': 'Zaksięgowany wynik',
  'adv.plan.metric.margin': 'Marża zysku',
  'adv.plan.saving': 'Zapisywanie …',
  'adv.plan.eventsTitle': 'Planowane zdarzenia',
  'adv.plan.eventsSub': 'Znane wpływy i wypływy, które nie są jeszcze zaksięgowane',
  'adv.plan.eventsHelp': 'Zdarzenia są widoczne w roku, do którego należy ich data. Nie są automatycznie przenoszone na następny rok; zmień datę, jeśli płatność zostanie przesunięta. Do prognozy przepływów pieniężnych trafiają tylko przyszłe, niezaksięgowane zdarzenia.',
  'adv.plan.eventsEmptyTitle': 'Brak planowanych zdarzeń',
  'adv.plan.eventsEmptyText': 'Bez zarejestrowanych zdarzeń krzywa przepływów pieniężnych jest płaska po bieżącym miesiącu, ponieważ zna tylko zaksięgowane dane.',
  'adv.plan.eventsNote': 'Zdarzenia z wcześniejszych miesięcy nie są uwzględniane w krzywej. Usuń zdarzenie po zaksięgowaniu płatności, aby nie zostało policzone dwa razy.',
  'adv.plan.eventNew': 'Nowe zdarzenie',
  'adv.plan.eventEdit': 'Edytuj zdarzenie',
  'adv.plan.eventSave': 'Zapisz zdarzenie',
  'adv.plan.eventSaved': 'Zdarzenie zostało zapisane',
  'adv.plan.eventSaveFailed': 'Nie udało się zapisać zdarzenia',
  'adv.plan.eventDeleted': 'Zdarzenie zostało usunięte',
  'adv.plan.eventLabel': 'Czego to dotyczy?',
  'adv.plan.eventLabelPh': 'Np. Dodatek urlopowy dla pracowników',
  'adv.plan.eventKind': 'Typ',
  'adv.plan.eventDate': 'Data',
  'adv.plan.eventDirection': 'Kierunek',
  'adv.plan.eventDirectionHint': 'Wypływ zmniejsza stan gotówki, wpływ go zwiększa.',
  'adv.plan.directionOut': 'Z rachunku',
  'adv.plan.directionIn': 'Na rachunek',
  'adv.plan.eventAmount': 'Kwota',
  'adv.plan.kind.salary': 'Wynagrodzenia i premie',
  'adv.plan.kind.tax': 'Podatki i opłaty',
  'adv.plan.kind.supplier': 'Płatność dla dostawcy',
  'adv.plan.kind.investment': 'Inwestycja',
  'adv.plan.kind.loan': 'Kredyty i raty',
  'adv.plan.kind.other': 'Inne',
  'adv.tab.reports': 'Raporty',
  'adv.tab.benchmark': 'Porównanie',
  'adv.basisCmp.title': 'Podstawa porównania',
  'adv.basisCmp.sub': 'Z czym faktycznie porównywane są liczby',
  'adv.basisCmp.help': 'Poniższe wskaźniki nie są porównywane z innymi firmami. Dwa są mierzone względem własnych danych firmy z poprzedniego roku, a dwa względem stałego progu. Każdy wiersz jest oznaczony, którego przypadku dotyczy.',
  'adv.basisCmp.year': 'Rok obrotowy',
  'adv.basisCmp.against': 'W porównaniu z',
  'adv.basisCmp.againstValue': 'Własne dane z {year}',
  'adv.basisCmp.source': 'Źródło danych',
  'adv.basisCmp.sourceValue': 'Dane zaksięgowane w Plumme',
  'adv.basisCmp.industry': 'Dane branżowe',
  'adv.basisCmp.industryValue': 'Niedostępne',
  'adv.basisCmp.row.previousYear': 'vs {year}',
  'adv.basisCmp.row.threshold': 'vs stały próg',
  'adv.hero.tag': 'Wnioski SuperPlumma w tym miesiącu',
  'adv.hero.empty': 'AI Doradca potrzebuje zaksięgowanych przychodów, kosztów i pozycji otwartych, zanim będzie mógł udzielić konkretnych rad.',
  'adv.hero.freeCapital': 'Wolny kapitał',
  'adv.hero.notCalculated': 'nie obliczono',
  'adv.hero.healthScore': 'Wskaźnik kondycji',
  'adv.hero.waiting': 'oczekuje',
  'adv.hero.ask': 'Zapytaj SuperPlumma',
  'adv.hero.chatTitle': 'Czat z SuperPlumma',
  'adv.hero.chatHint': 'Porozmawiaj ze mną',
  'adv.hero.briefTag': 'Miesięczne wnioski od SuperPlumma · {year}',
  'adv.hero.healthLead': 'Kondycja finansowa:',
  'adv.hero.greeting.morning': 'Dzień dobry.',
  'adv.hero.greeting.day': 'Cześć.',
  'adv.hero.greeting.evening': 'Dobry wieczór.',
  'adv.hero.greetingNamed.morning': 'Dzień dobry, {name}.',
  'adv.hero.greetingNamed.day': 'Cześć, {name}.',
  'adv.hero.greetingNamed.evening': 'Dobry wieczór, {name}.',
  'adv.hero.tasksToday': 'Do zrobienia dzisiaj: {count}',
  'adv.hero.seeAnalysis': 'Zobacz analizę',
  'adv.hero.effectNote.earlierIn': 'wcześniejsze wpływy',
  'adv.hero.effectNote.overduePayables': 'przeterminowane wobec dostawców',
  'adv.hero.effectNote.vatToCover': 'do pokrycia',
  'adv.hero.effectNote.vouchersAtRisk': 'zakupy bez dowodu księgowego',
  'adv.overnight.title': 'SuperPlumma przejrzała',
  'adv.overnight.transactions': 'Przeanalizowane transakcje: {count}',
  'adv.overnight.vouchers': 'Sprawdzone dowody księgowe: {count}',
  'adv.overnight.risks': 'Ocenione ryzyka: {count}',
  'adv.overnight.recommendations': 'Znalezione rekomendacje: {count}',
  'adv.overnight.updated': 'Ostatnia aktualizacja {time}',
  'adv.analysis.title': 'Otwarta analiza AI księgowości',
  'adv.analysis.empty': 'Analiza jest teraz niedostępna.',
  'adv.feed.title': 'SuperPlumma czuwała',
  'adv.feed.sub': 'Co ostatnio zauważyłem',
  'adv.feed.help': 'Zmiany, które wykryłem w księgowości — nie rekomendacje. Czerwony jest pilny, żółty wymaga uwagi, zielony to tylko informacja.',
  'adv.feed.seeDetails': 'Zobacz szczegóły',
  'adv.feed.marginDown.title': 'Marża zysku spadła o {points} pkt proc.',
  'adv.feed.marginDown.body': 'W porównaniu z ubiegłym rokiem. Warto się przyjrzeć, zanim stanie się to trendem.',
  'adv.feed.marginUp.title': 'Marża zysku wzrosła o {points} pkt proc.',
  'adv.feed.marginUp.body': 'W porównaniu z ubiegłym rokiem. Nie trzeba nic robić — po prostu dobrze wiedzieć.',
  'adv.feed.costLineJump.title': '{name} wzrosło o {pct} %',
  'adv.feed.costLineJump.body': 'Ta pozycja kosztowa rośnie szybciej niż pozostałe w porównaniu z ubiegłym rokiem.',
  'adv.feed.overdueSales.title': '{amount} należności od klientów jest przeterminowane',
  'adv.feed.overdueSales.body': 'Pieniądze są już zarobione — brakuje tylko wpływu.',
  'adv.feed.overduePurchases.title': '{amount} zobowiązań wobec dostawców jest przeterminowane',
  'adv.feed.overduePurchases.body': 'Przeterminowane zobowiązania wobec dostawców mogą oznaczać odsetki za zwłokę i opłaty za monity.',
  'adv.feed.concentration.title': 'Jeden klient odpowiada za {pct} % sprzedaży',
  'adv.feed.concentration.body': 'Duża zależność od klienta sprawia, że obroty są narażone, jeśli ten klient odejdzie.',
  'adv.feed.costsDown.title': 'Koszty spadły o {pct} % względem ubiegłego roku',
  'adv.feed.costsDown.body': 'Nie trzeba nic robić — po prostu dobrze wiedzieć.',
  'adv.feed.incomeUp.title': 'Obroty wzrosły o {pct} % względem ubiegłego roku',
  'adv.feed.incomeUp.body': 'Wzrost obliczono na podstawie zaksięgowanych przychodów w tym samym okresie.',
  'adv.feed.vouchersComplete.title': 'Wszystkie zakupy mają dowody księgowe',
  'adv.feed.vouchersComplete.body': 'Nic tutaj nie wymaga teraz twojej uwagi.',
  'adv.employees.title': 'Pracownicy i wynagrodzenia',
  'adv.employees.help': 'Moduł jest widoczny tylko dlatego, że firma ma pracowników lub listy płac. Dane pochodzą z zaksięgowanych kosztów wynagrodzeń i twoich list płac.',
  'adv.employees.count': 'Pracownicy',
  'adv.employees.share': 'Koszty wynagrodzeń / obroty',
  'adv.employees.cost': 'Zaksięgowane koszty wynagrodzeń',
  'adv.employees.runs': 'Listy płac w tym roku',
  'adv.employees.note': 'Udział wynagrodzeń obliczono na podstawie zaksięgowanych kont z serii 5000 w stosunku do tegorocznych obrotów.',
  'adv.employees.go': 'Zobacz wynagrodzenia',
  'adv.taskcenter.title': 'Moje zadania od SuperPlummy',
  'adv.taskcenter.all': 'Wszystkie',
  'adv.taskcenter.empty': 'Brak zadań w tej kategorii.',
  'adv.status.bucket.now': 'Wymaga działania teraz',
  'adv.profile.title': 'Profil doradcy',
  'adv.profile.help': 'Wszystko, co SuperPlumma wie o tym, jakich porad oczekujesz — bufor, cel, poziom ryzyka i częstotliwość — w jednym miejscu. Możesz tu wszystko zmienić.',
  'adv.profile.intro': 'Używam tego, aby porady były trafniejsze. Zmiana tutaj wpływa na to, jak ustalam priorytety — a nie na sposób prowadzenia księgowości.',
  'adv.profile.buffer': 'Docelowy bufor',
  'adv.profile.mainGoal': 'Najważniejszy cel',
  'adv.profile.mainGoal.revenue': 'Zwiększyć obroty',
  'adv.profile.mainGoal.profitability': 'Zwiększyć rentowność',
  'adv.profile.mainGoal.buffer': 'Zbudować bufor gotówkowy',
  'adv.profile.mainGoal.hiring': 'Zatrudniać',
  'adv.profile.mainGoal.investment': 'Inwestować',
  'adv.profile.mainGoal.workload': 'Zmniejszyć obciążenie pracą',
  'adv.profile.mainGoal.dividend': 'Przygotować firmę do wypłaty dywidendy',
  'adv.profile.risk': 'Preferowany poziom ryzyka',
  'adv.profile.risk.cautious': 'Bezpiecznie i ostrożnie',
  'adv.profile.risk.balanced': 'Zrównoważony',
  'adv.profile.risk.offensive': 'Otwarty na ryzyko',
  'adv.profile.cadence': 'Jak często chcesz otrzymywać porady',
  'adv.profile.cadence.daily': 'Codziennie',
  'adv.profile.cadence.weekly': 'Co tydzień',
  'adv.profile.cadence.monthly': 'Co miesiąc',
  'adv.profile.accountantInvolved': 'Angażuj księgowego w propozycje wymagające oceny',
  'adv.profile.investments': 'Planowane zdarzenia',
  'adv.profile.noInvestments': 'Brak zarejestrowanych',
  'adv.profile.season': 'Wzorzec sezonowy',
  'adv.profile.seasonText': 'Mocne miesiące: {strong}. Słabe miesiące: {weak}.',
  'adv.profile.noSeason': 'Za mało zaksięgowanych danych, aby dostrzec wzorzec.',
  'adv.profile.learned': 'Czego nauczyłem się z twoich wyborów',
  'adv.profile.nothingLearned': 'Jeszcze niczego się nie nauczyłem.',
  'adv.profile.saveFailed': 'Nie udało się zapisać profilu doradcy',
  'adv.buffer.recommended': 'Zalecany bufor',
  'adv.buffer.chosen': 'Wybrany bufor',
  'adv.buffer.edit': 'Dostosuj bufor płynności',
  'adv.buffer.editAria': 'Dostosuj bufor płynności wynoszący {amount}',
  'adv.buffer.title': 'Bufor płynności',
  'adv.buffer.auto': 'Automatyczna rekomendacja',
  'adv.buffer.autoHelp': 'SuperPlumma używa najwyższego wyliczonego zapotrzebowania. Obecna rekomendacja to {amount}.',
  'adv.buffer.custom': 'Własna kwota',
  'adv.buffer.customHelp': 'Używaj tej kwoty jako stałego progu w poradach, ryzykach i przepływach pieniężnych.',
  'adv.buffer.amount': 'Docelowy bufor w koronach',
  'adv.buffer.basisTitle': 'Podstawa automatycznej rekomendacji',
  'adv.buffer.basisMinimum': 'Poziom minimalny',
  'adv.buffer.basisMonthlyCosts': 'Koszty jednego miesiąca',
  'adv.buffer.basisTax': 'Wyliczona rezerwa na podatek',
  'adv.buffer.basisVat': 'Nadchodzący VAT',
  'adv.buffer.basisHelp': 'Automatyczny bufor używa najwyższej z tych kwot. To próg zarządczy, a nie pieniądze na osobnym koncie.',
  'adv.buffer.saving': 'Zapisywanie …',
  'adv.buffer.saved': 'Bufor płynności zapisany',
  'adv.buffer.invalid': 'Wpisz kwotę większą niż 0 kr.',
  'adv.buffer.unavailable': 'Ustawienie bufora jest teraz niedostępne.',
  'adv.buffer.saveFailed': 'Nie udało się zapisać bufora płynności.',
  'adv.generated.kicker': 'Otwarta analiza AI księgowości',
  'adv.generated.daily': 'Porada dnia',
  'adv.generated.monthly': 'Ten miesiąc',
  'adv.generated.previousMonthly': 'Poprzedni miesiąc',
  'adv.generated.loading': 'SuperPlumma czyta zaktualizowane dane doradcze …',
  'adv.generated.updated': 'Zaktualizowano {date}',
  'adv.generated.topOpportunity': 'Twój największy potencjał',
  'adv.generated.changes': 'Co dzieje się teraz?',
  'adv.generated.actions': 'To zrobiłbym teraz',
  'adv.generated.opportunities': 'Możliwości',
  'adv.generated.taxChecks': 'Podatki i VAT – punkty kontrolne',
  'adv.generated.more': 'Zobacz więcej możliwości i punktów kontrolnych',
  'adv.generated.nextStep': 'Następny krok',
  'adv.generated.readOnly': 'Analiza ma wyłącznie charakter doradczy i nie wykonuje żadnych działań.',
  'adv.generated.importCoverage': 'Na podstawie zaimportowanych sum i sald rozrachunków. Kontrola pojedynczych księgowań i kompletności dowodów księgowych jest ograniczona.',
  'adv.generated.refresh': 'Odśwież porady',
  'adv.generated.failed': 'Nie udało się teraz odświeżyć porady AI.',
  'adv.generated.unavailable': 'Żadna porada AI nie jest jeszcze gotowa',
  'adv.generated.empty': 'Nie ma jeszcze gotowych porad do wyświetlenia. Spróbuj odświeżyć porady.',
  'adv.generated.limitReached': 'Osiągnięto miesięczny limit nowych porad AI. Istniejące porady pozostają dostępne, a limit zostanie zresetowany w przyszłym miesiącu.',
  'adv.generated.todayCurrent': 'Dzisiejsza porada jest gotowa',
  'adv.generated.monthCurrent': 'Porada miesięczna została dziś zaktualizowana',
  'adv.generated.previousMonthCurrent': 'Podsumowanie wsteczne zostało dziś zaktualizowane',
  'adv.generated.noDataChanges': 'Brak nowych danych',
  'adv.generated.monthCooldown': 'Aktualizowane co tydzień',
  'adv.generated.todayAlreadyCurrent': 'Dzisiejsza porada jest już dostępna. Nową poradę dnia otrzymasz najwcześniej jutro.',
  'adv.generated.monthAlreadyCurrent': 'Porada miesięczna została dziś zaktualizowana. Można ją ponownie odświeżyć jutro, jeśli zmienią się dane księgowe.',
  'adv.generated.previousMonthAlreadyCurrent': 'Podsumowanie wsteczne zostało dziś zaktualizowane. Można je ponownie odświeżyć jutro, jeśli w okresie zostaną zaksięgowane nowe dane.',
  'adv.generated.noDataChangesInfo': 'Brak nowych danych księgowych od ostatniej porady. Nie użyto wywołania AI.',
  'adv.generated.monthCooldownInfo': 'Poradę miesięczną można zaktualizować raz w tygodniu, gdy zmieniła się podstawa księgowa.',
  'adv.generated.previousKept': 'Poprzednia porada pozostaje widoczna.',
  'adv.generated.type.booked': 'Zaksięgowany fakt',
  'adv.generated.type.calculated': 'Obliczone',
  'adv.generated.type.scenario': 'Scenariusz',
  'adv.generated.type.opportunity': 'Możliwość',
  'adv.generated.type.control': 'Punkt kontrolny',
  'adv.generated.confidence.high': 'Solidna podstawa',
  'adv.generated.confidence.medium': 'Średnia podstawa',
  'adv.generated.confidence.low': 'Słaba podstawa',
  'adv.health.title': 'Wskaźnik kondycji finansowej',
  'adv.health.sub': 'Ogólna ocena sytuacji finansowej firmy',
  'adv.health.help': 'Łączny wynik jest pokazywany tylko wtedy, gdy można obliczyć wszystkie cztery wskaźniki. Nieznane wartości nie dają punktów. Sprawdź podstawę danych, aby zobaczyć, czego brakuje.',
  'adv.health.badge.good': 'Dobra',
  'adv.health.badge.stable': 'Stabilna',
  'adv.health.badge.weak': 'Słaba',
  'adv.health.badge.none': 'Za mało danych',
  'adv.health.word.good': 'Dobra kondycja finansowa',
  'adv.health.word.stable': 'Stabilne finanse',
  'adv.health.word.weak': 'Wymaga uwagi',
  'adv.health.word.none': 'Ocena wstępna',
  'adv.health.emptyTitle': 'Za mało danych do wskaźnika kondycji',
  'adv.health.emptyText': 'Zaksięguj sprzedaż, zakupy i otwarte pozycje, aby włączyć analizę.',
  'adv.health.summaryFallback': 'SuperPlumma ocenia płynność, wzrost, rentowność i stabilność na podstawie Twoich ksiąg.',
  'vat.wordMva': 'VAT',
  'vat.wordMoms': 'VAT',
  'vat.exemptMva': 'Poza zakresem ustawy o VAT',
  'vat.exemptMoms': 'Poza VAT',
  'vat.rateLabel': '{{rate}} % {{word}}',
  'vat.zeroRated': '0 % {{suffix}}',
  'vat.zeroRatedSuffixMva': 'zwolnione',
  'vat.zeroRatedSuffixMoms': 'zwolnione z VAT',
  'vat.salesReverseCharge51': '51 - Odwrotne obciążenie przy sprzedaży',
  'vat.export52': '52 - Eksport/wywóz',
  'adv.health.category.likviditet': 'Płynność',
  'adv.health.category.vekst': 'Wzrost',
  'adv.health.category.lonnsomhet': 'Rentowność',
  'adv.health.category.stabilitet': 'Stabilność',
  'adv.health.note.noOpenPayables': 'Brak zarejestrowanych otwartych zobowiązań wobec dostawców',
  'adv.health.note.noDebt': 'Brak zobowiązań',
  'adv.health.note.unknown': 'Nieznane',
  'adv.health.note.receivablesVsPayables': 'Należności od klientów w porównaniu z otwartymi zobowiązaniami wobec dostawców',
  'adv.health.note.zeroPrevYearRevenue': 'Przychód z ubiegłego roku wynosi 0; nie można obliczyć procentowego wzrostu',
  'adv.health.note.needsPrevYear': 'Potrzebne dane z ubiegłego roku do porównania',
  'adv.health.note.revenueChangeVsPrevYear': 'Zmiana przychodów względem tego samego okresu ubiegłego roku',
  'adv.health.note.marginFromReport': 'Marża wyniku z rachunku zysków i strat',
  'adv.health.note.noBookedRevenue': 'Brak zaksięgowanych przychodów w wybranym roku',
  'adv.health.note.largestCustomerShare': 'Udział sprzedaży do największego klienta',
  'adv.health.note.needsInvoicesPerCustomer': 'Potrzebna sprzedaż fakturowana według klienta',
  'adv.help.healthCard': 'Wskaźnik kondycji to prosta suma od 0 do 100. Uwzględnia kilka rzeczy naraz, takich jak pieniądze na koncie, przychody, koszty i ryzyko. To wskazówka, a nie wyrok.',
  'adv.help.liquidity': 'Ta kwota to otwarte należności od klientów minus otwarte zobowiązania wobec dostawców. Nie pokazuje, ile pieniędzy jest na rachunku bankowym.',
  'adv.help.expectedBalance': 'Obliczone saldo planowane na koniec okresu. Liczby nie opierają się na uzgodnionym saldzie bankowym ani na pewnych terminach płatności.',
  'adv.help.expectedIn': 'Zaksięgowane przychody w widocznym okresie, a nie potwierdzone wpływy.',
  'adv.help.expectedOut': 'Zaksięgowane koszty w widocznym okresie, a nie potwierdzone wypływy.',
  'adv.help.cashBalance': 'Saldo to pieniądze dostępne w tej chwili w tym obliczeniu.',
  'adv.help.bookedIn': 'Zaksięgowane wpływy to przychody lub wpłaty, które są już ujęte w księgach za dany okres.',
  'adv.help.bookedOut': 'Zaksięgowane wypływy to koszty lub wypłaty, które są już ujęte w księgach za dany okres.',
  'adv.help.endBalance': 'Saldo końcowe to dzisiejsze saldo plus wpływy minus wypływy. Pokazuje, na jakim poziomie kończą się środki pieniężne w tym obliczeniu.',
  'adv.help.buffer': 'Bufor płynności to pożądany próg bezpieczeństwa. To nie jest osobne konto, lecz kwota, której Plumme używa, aby ostrzec, gdy środki pieniężne stają się zbyt niskie.',
  'adv.help.bufferMinimum': 'Poziom minimalny to najniższy bufor zalecany przez Plumme. Zapobiega temu, by zalecenie było zbyt niskie, gdy firma ma krótką historię.',
  'adv.help.monthlyCosts': 'Koszty jednego miesiąca to mniej więcej tyle, ile firma zwykle wydaje w miesiącu. Pomaga to przetrwać słabszy miesiąc.',
  'adv.help.taxReserve': 'Rezerwa podatkowa to pieniądze, które warto odłożyć na podatek, aby rachunek podatkowy nie był zaskoczeniem.',
  'adv.help.vatDue': 'Nadchodzący VAT to podatek od towarów i usług, który prawdopodobnie trzeba będzie zapłacić w najbliższym terminie VAT.',
});
